import React, { useContext, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import HeaderInternal from "./Header/HeaderInternal";
import { AccountContext } from "../store/AccountContext";

import { Helmet } from "react-helmet";

// Styles
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(4),
  },
  heading: {
    color: theme.palette.background.ffNavy,
    fontSize: "1.4rem",
    marginBottom: "20px",
    "@media (min-width:600px)": {
      fontSize: "1.8rem",
      lineHeight: "2.0rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2.2rem",
      lineHeight: "2.4rem",
    },
  },
  subHeading: {
    color: theme.palette.background.ffNavy,
    fontSize: "1.2rem",
    marginBottom: "20px",
    "@media (min-width:600px)": {
      fontSize: "1.6rem",
      lineHeight: "1.8rem",
    },
    "@media (min-width:960px)": {
      fontSize: "1.8rem",
      lineHeight: "2.0rem",
    },
  },
  bodytext: {
    color: theme.palette.background.ffNavy,
    marginBottom: theme.spacing(2),
  },
}));

const PrivacyPolicy = (props) => {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { loggedIn } = useContext(AccountContext);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FarmFLiX.tv | Privacy Policy</title>
        <meta name="description" content="Please read our Privacy Policy." />
      </Helmet>
      <>
        {loggedIn && <HeaderInternal />}
        {!loggedIn && <Header />}
      </>
      <Container fixed>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Container fixedcomponent="main" maxWidth="md">
              <div className={classes.paper}>
                <Typography
                  component="h1"
                  variant="h1"
                  className={classes.heading}
                >
                  Customer Privacy Policy (GDPR)
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  FarmFLiX delivered by Booya Ltd.(&quot;FarmFLiX,&quot;
                  &quot;us,&quot; &quot;we,&quot; or &quot;our&quot;) is
                  committed to protecting and respecting your privacy in
                  connection with your use of our website, www.farmflix.tv (the
                  &quot;Website(s)&quot;), applications (&quot;Apps&quot;) and
                  other products, services and features thereof (the Website,
                  the Apps and such other products, services and features are
                  collectively referred to herein as the &quot;Product&quot; or
                  &quot;Products&quot;, which may be updated from time-to-time
                  at the sole discretion of FarmFLiX). This privacy policy
                  (&quot;Privacy Policy&quot;) and any other documents referred
                  to herein set forth the basis on which any personal data we
                  collect from you, or that you provide to us, in connection
                  with the Products will be processed by us. Please read the
                  following carefully to understand our practices regarding your
                  personal data and how we will collect, use and disclose your
                  personal data.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>1. Data we may collect</b>
                  <br />
                  We may collect and process the following data about you:
                  Personal data including, for example, your name, e-mail
                  address, password, telephone number, data about your usage of
                  the Products and data collected by tracking technologies as
                  further described in section 4 below that may identify you as
                  an individual or allow online contact with you as an
                  individual.
                  <br />
                  <br />
                  FarmFLiX does not collect or process credit or debit card
                  (&quot;Payment Card&quot;) data. Our payment processor
                  collects Payment Card data with respect to purchases made
                  through the Website. Payment processors generally provide us
                  with some limited data related to you, such as a unique,
                  anonymous token that enables you to make additional purchases
                  using the data they’ve stored, and your card’s type,
                  expiration date, billing country, and the last four digits of
                  your card number.
                  <br />
                  <br />
                  Device information such as operating system version, device
                  type, and system performance data.
                  <br />
                  <br />
                  Data collected via tracking technologies, as fully described
                  in section 4.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>2. Confidentiality and security</b>
                  <br />
                  The security of your personal data is important to us. We
                  follow standards to protect the personal data submitted to us,
                  both during transmission and once it is received. If you have
                  any questions about the security of your personal data, you
                  can contact us at info@farmflix.tv. Except as described under
                  the &quot;Disclosure of Your Data&quot; section below, we do
                  not provide your personal data to any third party without your
                  specific consent, as defined by applicable law.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>3. Newsletters or other electronic communications</b>
                  <br />
                  If you sign up to receive promotional materials from us via
                  email and/or (push notifications) we will use the data you
                  give us to provide the communications you have requested. If
                  you inform us that you wish to cancel email promotional
                  materials by selecting &quot;unsubscribe&quot; at the bottom
                  of such communication or by emailing us at info@farmflix.tv,
                  we will remove you from our mailing list. If you no longer
                  wish to receive push notifications, you may turn them off at
                  the device level.
                  <br />
                  <br />
                  If you provide your phone number to us directly or through a
                  third-party for the specific purpose of receiving an SMS
                  message with a link to our Apps, you will receive such SMS
                  message (the &quot;SMS Service&quot;). Standard text message
                  rates will apply.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>4. Tracking technologies</b>
                  <br />
                  FarmFLiX and our analytics partners use technologies such as
                  cookies, beacons, tags, and scripts to enable a service to
                  recognise your device so you don&apos;t have to provide the
                  same data several times during one task, to recognise that you
                  may have already given a username and password so you
                  don&apos;t need to do it for every web page requested, and to
                  measure how people are using the Products.
                  <br />
                  <br />
                  We use local storage, such as HTML5, to store content data and
                  preferences. Third parties with whom we partner to provide
                  certain features on the Products also use HTML5 to collect and
                  store data. Various browsers may offer their own management
                  tools for removing HTML5.
                  <br />
                  <br />
                  We partner with third parties, such as Facebook and Google, to
                  manage our advertising of the Products on other sites or
                  platforms as well as across your other devices based on your
                  past visits to our Website. Our third party partners may use
                  technologies such as cookies to gather data about your
                  activities within the Products to deliver such advertising to
                  you, such as retargeting ads. We are not always able to
                  respond to do-not-track signals. Please note that this does
                  not opt you out of being served ads. You may continue to
                  receive generic ads on these third party platforms. You may
                  also opt out of receiving ads across devices by adjusting your
                  ad preference in your Google account.
                  <br />
                  <br />
                  We use third party trackers to let us know when users have
                  visited the Products by &quot;clicking-through&quot; our
                  sponsored advertising or content hosted on third party
                  platforms. The Products use Google Analytics code to gather
                  statistical data. Google Analytics sets cookies to help us
                  accurately estimate the number of visitors to the Products and
                  the volumes of usage of the Products. This is done to ensure
                  that the Products are available when you want them and are
                  fast. For more data on how Google Analytics processes this
                  data, visit www.google.com/analytics.
                  <br />
                  <br />
                  MOBILE ANALYTICS
                  <br />
                  We use mobile analytics software to allow us to better
                  understand the functionality of our mobile software on your
                  phone. This software may record data such as how often you
                  engage with the Products, the events that occur within the
                  Products, aggregated usage and performance data, and where the
                  Applications were downloaded from. We may link the data we
                  store within the analytics software to any personal data you
                  submit within the mobile application.
                  <br />
                  <br />
                  LOG FILES
                  <br />
                  As true of most websites, we gather certain data and
                  automatically and store it in log files. This data may include
                  Internet Protocol (IP) addresses, browser type, internet
                  service provider (ISP), referring/exit pages, operating
                  system, date/time stamp, and/or clickstream data.
                  <br />
                  <br />
                  If you receive the HTML-formatted version of our emails, your
                  opening of the email is notified to us and saved. Your clicks
                  on links in the email are also saved. These and the open
                  statistics are used in aggregate form to give us an indication
                  of the popularity of the content and to help us make decisions
                  about future content and formatting.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>5. Where we store your personal data</b>
                  <br />
                  All data you provide to us through the Products is stored on
                  our secure servers located in the U.K. Any payment
                  transactions will be encrypted using SSL technology; all
                  payment data is stored with our payment processor and is never
                  stored on FarmFLiX servers. Where we have given you (or where
                  you have chosen) a password which enables you to access
                  certain parts of the Products, you are responsible for keeping
                  this password confidential. We ask you not to share a password
                  with anyone, and suggest that your change your password
                  frequently.
                  <br />
                  <br />
                  Unfortunately, the transmission of data via the Internet is
                  not completely secure. Although we will do our best to protect
                  your personal data, we cannot guarantee the security of your
                  data transmitted to the Products; any transmission is at your
                  own risk. Once we have received your data, we will use strict
                  procedures and security features to try to prevent
                  unauthorised access.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>6. Single sign-on</b>
                  <br />
                  You may be able to log-in to our Products using sign-in
                  services such as Facebook Connect or an Open ID provider.
                  These services will authenticate your identity, provide you
                  the option to share certain personal data (such as your name
                  and email address) with us, and to pre-populate our sign-up
                  form.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>7. Your data rights</b>
                  <br />
                  As you may know, a recent European Union law called the
                  General Data Protection Regulation (&quot;GDPR&quot;) give
                  certain rights to applicable individuals in relation to their
                  personal data. Accordingly, we have implemented transparency
                  and access controls to help such users, including residents of
                  the EU, Switzerland, and the United Kingdom exercise those
                  rights. As required under applicable law, the rights afforded
                  to you are:
                  <br />
                  <br />
                  A right of access: you have the right to obtain (i)
                  confirmation as to whether personal data concerning you are
                  processed or not and, if processed, to obtain (ii) access to
                  such data and a copy thereof.
                  <br />
                  <br />
                  A right to rectification: you have the right to obtain the
                  rectification of any inaccurate personal data concerning you.
                  You also have the right to have incomplete personal data
                  completed, including by means of providing a supplementary
                  statement.
                  <br />
                  <br />
                  A right to erasure: in some cases, you have the right to
                  obtain the erasure of personal data concerning you. Upon
                  request, FarmFLiX will permanently anonymise your data such
                  that it can never be reconstructed to identify you as an
                  individual. However, this is not an absolute right and
                  FarmFLiX may have legal or legitimate grounds for keeping such
                  data.
                  <br />
                  <br />
                  A right to restriction of processing: in some cases, you have
                  the right to obtain restriction of the processing of your
                  personal data.
                  <br />
                  <br />
                  A right to data portability: you have the right to receive the
                  personal data concerning you which you have provided to
                  FarmFLiX, in a structured, commonly used and machine-readable
                  format, and you have the right to transmit those data to
                  another controller without hindrance from FarmFLiX. This right
                  only applies when the processing of your personal data is
                  based on your consent or on a contract and such processing is
                  carried out by automated means.
                  <br />
                  <br />
                  A right to object to processing: you have the right to object
                  at any time, on grounds relating to your particular situation,
                  to processing of personal data concerning you when such
                  processing is based on the legitimate interest of FarmFLiX.
                  FarmFLiX may, however, invoke compelling legitimate grounds
                  for continued processing. When your personal data is processed
                  for direct marketing purposes, you have the right to object at
                  any time to the processing of such data. You may, in
                  particular, exercise that right by clicking on the
                  &quot;unsubscribe&quot; link provided at the bottom of any
                  messages received, or by managing your privacy preferences by
                  logging in to your FarmFLiX account.
                  <br />
                  <br />
                  A right to lodge a complaint with the competent supervisory
                  authority: you have the right to contact the supervisory
                  authority to complain about FarmFLiX personal data protection
                  practices.
                  <br />
                  <br />
                  A right to give instructions concerning the use of your data
                  after your death: as required by applicable law, you may have
                  the right to give FarmFLiX instructions concerning the use of
                  your personal data after your death. To exercise one or more
                  of these rights, you can email info@farmflix.tv
                  <br />
                  <br />
                  You may access your personal data to modify or update at any
                  time via an online account, or by emailing info@farmflix.tv
                  <br />
                  <br />
                  We will respond to your request in a reasonable timeframe in
                  accordance with applicable law.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>8. Uses made of the data</b>
                  <br />
                  We use information held about you in the following ways:
                  <br />
                  <ul>
                    <li>To provide you with the Products.</li>
                    <li>
                      To answer your questions or requests for information or
                      handle your complaints.
                    </li>
                    <li>
                      To ensure that content provided by the Products is
                      presented in the most effective manner for you and for
                      your computer or other device.
                    </li>
                    <li>
                      To provide you with promotional communications, such as
                      email, to the extent that you have provided consent to
                      receive such communications under applicable law.
                    </li>
                    <li>
                      To carry out our obligations arising from any agreements
                      entered into between you and us.
                    </li>
                    <li>
                      To allow you to participate in interactive features of the
                      Products, when you choose to do so.
                    </li>
                    <li>
                      To notify you about updates or changes to Product features
                      and content.
                    </li>
                    <li>
                      To understand your broad, non-specific geographic location
                      to help us identify groups of users by general geographic
                      market (such as zip code, state or country).
                    </li>
                    <li>
                      To serve our advertisements to you through third party
                      platforms, such as Facebook or Google, on other sites and
                      apps or across your devices, to the extent that you have
                      provided consent for such uses under applicable law.
                    </li>
                    <li>
                      To provide you with the SMS Service to the extent that you
                      have provided consent for such practices under applicable
                      law.
                    </li>
                    <li>
                      We may also ask you to complete surveys that we use for
                      research purposes, although you do not have to respond to
                      them.
                    </li>
                    <li>To manage your payments and orders.</li>
                    <li>
                      If you are an existing customer, we will only contact you
                      by electronic means (e-mail, SMS or in-Product
                      communication) with information about products and
                      services similar to those which were the subject of a
                      previous sale to you, except if you opt-out to such
                      communications.
                    </li>
                  </ul>
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>9. Legal bases of personal data processing</b>
                  <br />
                  In accordance with GDPR, FarmFLiX provides the following
                  information regarding its Article 6 legal bases for personal
                  data processing:
                  <br />
                  <ul>
                    <li>
                      The performance of the contract (the FarmFLiX Terms &amp;
                      Conditions) between you and FarmFLiX for the data
                      processing relating to your use of FarmFLiX Products
                      (including your orders and payments);
                    </li>
                    <li>
                      FarmFLiX‘s legitimate interest, more specifically:
                      <ul>
                        <li>
                          Our business interest in providing you with emails and
                          push notifications for timely introductory materials
                          and information about your FarmFLiX account, our
                          Product features and updates, and offers to upgrade
                          your free account to a subscription account.
                        </li>
                        <li>
                          Our financial interest in providing you with
                          promotional offers and/or discounts with respect to
                          paid subscriptions and special offerings.
                        </li>
                        <li>
                          Our business interest in offering you particularized
                          or adapted content based on your usage of the
                          Products.
                        </li>
                        <li>
                          Our business interest in collecting data regarding
                          your general usage activities for the purpose of
                          improving our FarmFLiX user experience.
                        </li>
                        <li>
                          Our business interest in requesting that you partake
                          in Product surveys in order to better understand your
                          needs and expectations.
                        </li>
                        <li>
                          Our financial interest in providing you the
                          opportunity to purchase FarmFLiX subscriptions for the
                          benefit of a third party through the FarmFLiX
                          &quot;gifting&quot; program.
                        </li>
                        <li>
                          Our business interest in providing you with customer
                          service communications regarding your account,
                          questions about our content offerings or your
                          mindfulness practice, or any other matters directed to
                          customer service staff, in order to have clear and
                          easy communication with you and to respond to all your
                          requests.
                        </li>
                        <li>
                          Our business interest in collecting data related to
                          unplanned downtime or errors in the Products.
                        </li>
                        <li>
                          Our business interest in complying with our legal
                          obligations, such as maintaining accurate financial
                          records.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>10. Disclosure of your data</b>
                  <br />
                  We may disclose your personal data to any member of our group,
                  which means our subsidiaries, our ultimate holding company and
                  its subsidiaries.
                  <br />
                  <br />
                  We may also disclose your personal data to third parties as
                  follows:
                  <br />
                  <ul>
                    <li>
                      In some circumstances, based on your specific requests, we
                      may need to disclose your personal data to a third party
                      so that it can provide a service you have requested from
                      such party, or fulfil a request for data from such party.
                      An example of this is the SMS Service.
                    </li>
                    <li>
                      In some circumstances, we may disclose the personal data
                      that you have provided to FarmFLiX to a third party that
                      offers and/or provides goods or services complementary to
                      our own for the purpose of enhancing our users’
                      experiences by offering you integrated or complementary
                      functionality, complementary services or bundled pricing
                      options.
                    </li>
                    <li>
                      If FarmFLiX‘s service providers (like hosting, IT
                      maintenance, market analytics, and payment service
                      providers) require this data to provide services to
                      FarmFLiX. FarmFLiX requires each of its service providers
                      to agree to maintain the confidentiality and security of
                      your personal data.
                    </li>
                    <li>
                      In the event that we sell or buy any business or assets,
                      in which case we may disclose your personal data to the
                      seller or buyer of such business or assets when the sale
                      or acquisition is complete.
                    </li>
                    <li>
                      If FarmFLiX or substantially all of our assets are
                      acquired by a third party, in which case personal data
                      held by us about our customers will be one of the
                      transferred assets.
                    </li>
                    <li>
                      If we are under a duty to disclose or share your personal
                      data in order to comply with any legal obligation such as
                      to comply with a witness summons, bankruptcy proceedings,
                      similar legal process, or in order to enforce or apply our
                      agreements with you; or to protect the rights, property,
                      or safety of FarmFLiX, our customers, or others. This
                      includes exchanging data with other companies and
                      organizations for the purposes of fraud protection and
                      credit risk reduction.
                    </li>
                    <li>
                      With third parties, such as Facebook, in order to serve
                      FarmFLiX advertisements on such third party platforms, to
                      the extent that you have consented to such practices under
                      applicable law.
                    </li>
                  </ul>
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>11. Data retention</b>
                  <br />
                  The retention periods applied by FarmFLiX comply with
                  applicable legislation in effect on the date hereof, namely:
                  <br />
                  <ul>
                    <li>
                      For data relating to your account: such data will not be
                      retained beyond your request that your account be deleted.
                      FarmFLiX may, however, invoke legitimate grounds for
                      continued retention of data which will prevent you from
                      gaming FarmFLiX product access to restricting additional
                      free product trials.
                    </li>
                    <li>
                      For transactional data relating to your purchases: such
                      data is kept for the entire period of the contractual
                      relationship, then in accordance with legal obligations
                      and applicable statute of limitation periods. Please note
                      that this data does not include Payment Card information,
                      which is processed by our third-party payment processors,
                      and not FarmFLiX.
                    </li>
                    <li>
                      For data collected based on your consent to receive our
                      marketing communications: we will use such data until you
                      withdraw consent or applicable law requires that such data
                      is no longer used.
                    </li>
                    <li>
                      When your data are collected in the context of
                      requests/queries: such data are kept for the period
                      necessary to process and reply to such requests or
                      queries.
                    </li>
                    <li>
                      When cookies or other trackers are placed on your
                      terminal, they are kept for a period of 12 months.
                    </li>
                    <li>
                      Other data will be kept as long as necessary for the
                      purposes pursued and in compliance with our legal
                      obligations, including the applicable statute of
                      limitations.
                    </li>
                  </ul>
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>12. Withdrawal of consent for processing activities</b>
                  <br />
                  To the extent that you have provided appropriate consent under
                  applicable law to certain processing activities, such consent
                  can be withdrawn at any time by emailing info@farmflix.tv
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>13. Links to third party sites</b>
                  <br />
                  The Products may, from time to time, contain links to and from
                  the Products of our partner networks, advertisers and
                  affiliates. If you follow a link to any of these external
                  websites, please note that these websites have their own
                  privacy policies and that we do not accept any responsibility
                  or liability for these websites or their policies. Please
                  check these policies before you submit any personal data to
                  these external websites.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>14. Social media widgets</b>
                  <br />
                  Our Products include social media features, such as the
                  Facebook Like button, and widgets, such as the &quot;Share
                  This&quot; button, or interactive mini-programs. These
                  features may collect your Internet protocol address, which
                  page you are visiting on or Products, and may set a cookie to
                  enable the feature to function properly. Social media features
                  and widgets are hosted by a third party or hosted directly on
                  our Products. Your interactions with these features are
                  governed by the privacy statement of the company providing it.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>15. Use of FarmFLiX by minors</b>
                  <br />
                  You must be 18 years of age, or the age of majority in your
                  province, territory or country, to sign up as a registered
                  user of the Products. Individuals under the age of 18, or the
                  applicable age of majority, may utilize the Products only with
                  the involvement and consent of a parent or legal guardian,
                  under such person&apos;s account.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>16. Data posted on forums</b>
                  <br />
                  FarmFLiX users may have the ability to post content to one or
                  more FarmFLiX forums. All such users may request and obtain
                  removal of such posted content by contacting FarmFLiX at
                  info@farmflix.tv and specifically identifying the content to
                  be removed. Please be advised that any such removal does not
                  ensure complete or comprehensive removal of all traces of the
                  content posted on the FarmFLiX forum(s).
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>17. Changes to our privacy policy</b>
                  <br />
                  We may update this Privacy Policy to reflect changes to our
                  data practices. If we make any material changes we will notify
                  you by in-Product message, email (sent to the e-mail address
                  specified in your account) or by means of a notice in the
                  Products prior to the change becoming effective. We encourage
                  you to periodically review this page for the latest data on
                  our privacy practices.
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.bodytext}
                >
                  <b>18. Contact and EEA Registered Agent</b>
                  <br />
                  Questions, comments and requests regarding this privacy policy
                  are welcomed and should be addressed to info@farmflix.tv.
                  <br />
                  <br />
                  FarmFLiX’s physical address is 33 Ballynoe Road, Antrim, BT41
                  2QX
                </Typography>
              </div>
              <Typography
                component="p"
                variant="body2"
                className={classes.bodytext}
              >
                <b>Last Updated</b>: 03 May 2025
              </Typography>
            </Container>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
